import React, {useEffect, useState} from "react";
import {Table, Input, Flex} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {HttpService} from "../../services/http/Http.service";
import {AlertStatus, NonPaymentAlertSimpleDto} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";
import UserDetailsButton from "../userDetails/UserDetailsButton";
import Suspend from "../../components/suspend/Suspend";
import {SUSPENSION_REASON_LABELS} from "../../model/models";

export default function NonPaymentAlertPage() {
    const [alerts, setAlerts] = useState<NonPaymentAlertSimpleDto[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedAlerts, setSelectedAlerts] = useState<NonPaymentAlertSimpleDto[]>([]);

    const status = AlertStatus.CREATO;
    const [searchText, setSearchText] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchText);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchText]);

    useEffect(() => {
        loadAlerts(status, debouncedSearch);
    }, [status, debouncedSearch, currentPage]);

    const loadAlerts = async (status: AlertStatus, query?: string) => {
        setLoading(true);
        try {
            const params = {
                page: currentPage - 1,
                size: pageSize,
                query: query || "",
            };
            const response = await HttpService.getInstanceAxios().get(`/alert/non-payment/status/${status}`, {params});
            setAlerts(response.data.content);
            setTotalItems(response.data.totalElements);
        } catch (error) {
            HttpErrorService.handle("Errore durante il recupero degli alert", error, true);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "Codice Fiscale",
            dataIndex: "fiscalCode",
            key: "fiscalCode",
        },
        {
            title: "Cognome Nome",
            dataIndex: "fullName",
            key: "fullName",
        },
        {
            title: "Protocollo di archiviazione",
            dataIndex: "archiveProtocol",
            key: "archiveProtocol",
            render: (text: string | null) => text || "-",
        },
        {
            title: "Scadenza rata",
            dataIndex: "deadline",
            key: "deadline",
            render: (text: string) => new Date(text).toLocaleDateString("it-IT"),
        },
        {
            title: "Azione",
            key: "action",
            render: (record: NonPaymentAlertSimpleDto) => (
                <UserDetailsButton personID={record.personId} combinatorID={record.simulatorId}/>
            ),
        },
    ];

    return (
        <>
            <div className="container-search" style={{margin: "16px 0"}}>
                <Input
                    size="large"
                    style={{width: "100%", maxWidth: "480px"}}
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    addonBefore={<SearchOutlined/>}
                    placeholder="Nome, Cognome, Codice Fiscale, Numero Protocollo"
                />
            </div>

            <Table
                rowKey={(record) => record.id}
                rowSelection={{
                    selectedRowKeys,
                    onChange: (keys, rows) => {
                        setSelectedRowKeys(keys);
                        setSelectedAlerts(rows);
                    },
                }}
                columns={columns}
                dataSource={alerts}
                loading={loading}
                pagination={{
                    showSizeChanger: false,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalItems,
                    onChange: (page) => setCurrentPage(page),
                }}
            />

            <Flex justify={"flex-end"} style={{gap: '5px'}}>
                <Suspend selectedSimulatorPersonPairs={selectedAlerts.map((alert) => ({
                    simulatorId: alert.simulatorId,
                    personId: alert.personId,
                }))} onSuccess={() => {
                    setSelectedRowKeys([]);
                    setSelectedAlerts([]);
                    loadAlerts(status, debouncedSearch)
                }} reason={SUSPENSION_REASON_LABELS.RATA_NON_PAGATA}/>
            </Flex>
        </>
    );
}
